import { create } from "zustand";
import { persist } from "zustand/middleware";

import { DEFAULT_LANGUAGE, type Language } from "@/i18n/constant";

interface LanguageStore {
	language: Language;
	setLanguage: (language: Language) => void;
}

export const useLanguageStore = create<LanguageStore>()(
	persist(
		(set) => ({
			language: DEFAULT_LANGUAGE,
			setLanguage: (language: Language) => set({ language }),
		}),
		{
			name: "marinavalue-language",
		},
	),
);
